export function addTitleToIcon(icon: SVGElement, title: string = 'Icon Title'): SVGElement {
  addRoleImgToIcon(icon);
  const titleElement = document.createElementNS('http://www.w3.org/2000/svg', 'title');
  titleElement.textContent = title;
  icon.prepend(titleElement);
  icon.setAttribute('aria-label', title);
  return icon;
}

export function addPresentationToIcon(icon: SVGElement) {
  icon.setAttribute('role', 'presentation');
  return icon;
}

export function addLabeledbyToIcon(icon: SVGElement, describedById: string) {
  addRoleImgToIcon(icon);
  icon.setAttribute('aria-labelledby', describedById);
  return icon;
}

export function hideIconFromAssistiveTechnology(icon: SVGElement) {
  icon.setAttribute('aria-hidden', 'true');
  icon.removeAttribute('role');
  icon.removeAttribute('aria-label');
  icon.removeAttribute('aria-labelledby');
  const titleElement = icon.querySelector('title');
  if (titleElement) {
    titleElement.remove();
  }
  return icon;
}

function addRoleImgToIcon(icon: SVGElement) {
  icon.removeAttribute('aria-hidden');
  icon.setAttribute('role', 'img');
  return icon;
}
